import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

export default class CustomIcon extends React.Component {
  static propTypes = {
    /** The svg element to display */
    children: PropTypes.node.isRequired,
    /** The color of the icon */
    color: PropTypes.string.isRequired,
    /** The size of the icon */
    size: PropTypes.oneOf(['small', 'medium', 'large', 'xlarge'])
  };

  static defaultProps = {
    size: 'medium',
    color: 'black'
  };

  render() {
    const { size, color } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>{this.props.children}</g>
      </svg>
    );
  }
}
